





























import { Vue, Component, Prop } from "vue-property-decorator";

export type item = {
  id: number;
  type: number;
  value: number;
  max: number;
  img: string;
};

@Component<ItemSelection>({})
export default class ItemSelection extends Vue {
  @Prop({ required: true })
  selected: number;
  @Prop({ required: true })
  items: item[];

  isPath(path: string): boolean {
    return path.includes("/");
  }
}
